<ion-header>
  <ion-toolbar>
    <super-back-button slot="start" [modalController]="modalController"></super-back-button>
    <ion-title>Notifications</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div sxPadding="medium" sxCol sxGap="10px" *ngIf="defaultNotificationPrefs">

    <div *ngFor="let pref of activeOrgUserNotificationPrefs$ | async" sxRow sxPadding="medium" sxRadius="medium"
      sxBackground="light" sxAlign="center">
      <p sxWidth="fill">{{pref.title}}</p>
      <div sxRow sxGap="20px">
        <div sxCenterize="col" sxGap="5px">
          <p sxTextSize="10px" sxColor="two" sxMargin="0">Email</p>
          <ion-checkbox
            [checked]="pref.channelsEnabled && pref.channelsEnabled?.indexOf(NotificationChannel.email) > -1"
            (ionChange)="onToggle($event, pref, NotificationChannel.email)"></ion-checkbox>
        </div>
        <div sxCenterize="col" sxGap="5px">
          <p sxTextSize="10px" sxColor="two" sxMargin="0">Mobile</p>
          <ion-checkbox
            [checked]="pref.channelsEnabled && pref.channelsEnabled?.indexOf(NotificationChannel.mobile_app) > -1"
            (ionChange)="onToggle($event, pref, NotificationChannel.mobile_app)"></ion-checkbox>
        </div>
      </div>
    </div>

  </div>


</ion-content>